import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { CATEGORIES, GROUPS } from '../constants';

/**
 * Create ordered list of groups formatted for display purposes
 */
export const createOrderedGroups = () => {
  const { project, messaging, content, audience, insights } = GROUPS;

  return [project, messaging, content, audience, insights];
};

/**
 * Create categories list to pass to child component
 */
export const createCategories = (
  categories: string[],
  featureFlag: boolean,
  isAssetManagerIndexFFEnabled: boolean,
) =>
  categories.map((category) => {
    const { id, name, permissions } = CATEGORIES[category];
    const isJourneys = id === CATEGORIES.journeys.id;
    const isTemplates = id === CATEGORIES.templates.id;

    return {
      id,
      name: isTemplates && isAssetManagerIndexFFEnabled ? 'Templates and Creative Library' : name,
      permissions:
        isJourneys && featureFlag
          ? [...permissions, PROJECT_PERMISSIONS.CampaignMediumsGroup]
          : permissions,
    };
  });
